import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getCookie } from '../utils/cookieUtils'

const CONSENT_KEY = 'mad_cookie_consent'

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY)
    if (!consent) {
      setVisible(true)
    }
  }, [])

  const saveConsent = (value) => {
    localStorage.setItem(CONSENT_KEY, value)
    setVisible(false)
  }

  const handleAccept = () => saveConsent('accepted')
  const handleDeny = () => saveConsent('denied')

  if (!visible) {
    return null
  }

  const country = getCookie('selectedCountry') || 'ba'
  const cookiePolicyUrl = `/${country}/politikakolacica`

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-end md:items-center justify-center bg-black/40 p-0 md:p-4"
      onClick={handleDeny}
      role="presentation"
    >
      <div
        className="w-full md:max-w-lg bg-white shadow-xl rounded-t-2xl md:rounded-2xl p-6 md:p-8"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="cookie-banner-title"
        aria-describedby="cookie-banner-description"
      >
        <h2
          id="cookie-banner-title"
          className="text-lg md:text-xl font-luxor text-[#111111] mb-3"
        >
          Kolačići
        </h2>
        <p
          id="cookie-banner-description"
          className="text-sm md:text-base font-luxorlight text-[#555555] leading-relaxed mb-6"
        >
          Koristimo kolačiće kako bismo poboljšali vaše iskustvo na webshopu.
          Nastavkom korištenja prihvatate upotrebu kolačića u skladu s našom{' '}
          <Link
            to={cookiePolicyUrl}
            className="text-[#DCA950] underline hover:text-[#c49540]"
            onClick={(e) => e.stopPropagation()}
          >
            politikom kolačića
          </Link>
          .
        </p>
        <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            onClick={handleDeny}
            className="w-full sm:w-auto px-6 h-[44px] border border-[#C2C2C2] text-[#333333] font-medium hover:bg-gray-50 transition-colors"
          >
            Odbij
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="w-full sm:w-auto px-6 h-[44px] bg-[#DCA950] text-white font-medium hover:bg-[#c49540] transition-colors"
          >
            Prihvati sve
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
